module.exports = __webpack_public_path__ + "aba6d2e8.png";